import { render, staticRenderFns } from "./ForEmployersButton.vue?vue&type=template&id=51dff229&"
import script from "./ForEmployersButton.vue?vue&type=script&lang=js&"
export * from "./ForEmployersButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports